import { FC, default as React } from 'react';
import { useStyletron } from 'baseui';

interface LinearLoaderProps {
    loading: boolean;
}

export const LinearLoader: FC<LinearLoaderProps> = ({ loading }) => {
    const [css, theme] = useStyletron();

    const loaderClassName = css({
        width: '100%',
        height: '2px',
        backgroundColor: theme.colors.backgroundLightAccent,
        position: 'relative',
        overflow: 'hidden',
    });

    const loadingIndicatorClassName1 = css({
        position: 'absolute',
        height: '100%',
        width: '25%',
        background: theme.colors.accent,
        left: 0,
        animationIterationCount: 'infinite',
        animationDuration: '1.6s',
        animationTimingFunction: 'linear',
        transform: 'translateX(-100%)',
    });

    const loadingIndicatorClassName2 = css({
        position: 'absolute',
        height: '100%',
        width: '25%',
        background: theme.colors.accent,
        left: 0,
        animationIterationCount: 'infinite',
        animationDuration: '1.6s',
        animationTimingFunction: 'linear',
        animationDelay: '0.3s',
        transform: 'translateX(-100%)',
    });

    const animationClassName = css({
        animationName: 'linearLoading',
    });

    return (
        <div className={loaderClassName}>
            <span
                className={`${loadingIndicatorClassName1} ${
                    loading ? animationClassName : ''
                }`}
            />
            <span
                className={`${loadingIndicatorClassName2} ${
                    loading ? animationClassName : ''
                }`}
            />
        </div>
    );
};
